export default __webpack_public_path__ + "static/media/GMaduroTorpedo.084c8fe5.png";